module.exports = __webpack_public_path__ + "static/img/closing_the_ethnicity_stay_gap.a53e411.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/research/closing_the_ethnicity_stay_gap.png
// module id = hZ7q
// module chunks = 0